import styled from "styled-components";

const icon = "transparent url(/icons/related-links.svg) no-repeat";

export const KeyPointList = styled.div`
  ul {
    padding: 0;
    list-style: none;
  }
  li {
    position: relative;
    padding-bottom: 22px;
    padding-left: 31px;
    font-size: 15px;
    font-family:  ${({ theme }) => theme.default.fontFamily.secondaryFont};
    font-weight: 400;
    text-decoration: underline;
    &:before {
      content: " ";
      width: 19px;
      height: 19px;
      display: block;
      background: ${icon};
      background-size: 19px;
      border-radius: 50%;
      position: absolute;
      left: 2px;
      top: 0;
      z-index: 2;
      .article-climate & {
        background: ${icon};
      }
      .article-sgi & {
        background: ${icon};
      }
    }
    &:after {
      content: "";
      display: block;
      position: absolute;
      width: 1px;
      height: 100%;
      background: ${(props) => props.theme.default.color.primary};
      left: 11px;
      top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      &:after {
        display: none;
      }
    }
    a:hover {
      color: ${(props) => props.theme.default.color.primary};
    }
  }
`;
